// extracted by mini-css-extract-plugin
module.exports = {"input":"input_input__DK7_B","disabled":"input_disabled__Z5iWF"};